export default __webpack_public_path__ + "static/media/placeholder_portrait_white.98739fd1.svg";